import { createMemoryHistory } from 'history';

const isBrowser = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

const history = isBrowser ? createMemoryHistory() : null;

export default history;
